
import { useState, useEffect } from 'react';
import { memberships } from '../../../mocks/memberships';

export default function Membership() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerView = 4;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => 
        prev + 1 >= memberships.length ? 0 : prev + 1
      );
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Memberships & <span className="text-teal-600">Associations</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Proud members of leading industry organizations and associations
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)`
            }}
          >
            {memberships.map((member) => (
              <div
                key={member.id}
                className="w-1/2 md:w-1/3 lg:w-1/4 flex-shrink-0 px-4"
              >
                <div className="bg-gray-50 rounded-lg p-8 h-32 flex items-center justify-center hover:shadow-lg transition-all duration-300">
                  <img
                    src={member.logo}
                    alt={member.name}
                    className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
